import React from 'react';
import DisciplineItem from './DisciplineItem'
import TablePagination from 'components/Pagination/TablePagination';
import HeadersDisciplines from './HeadersDisciplines';

function DisciplineList({
                       disciplines,
                       navigateToDiscipline,
                       checkedDisciplineIds,
                       discipline_ids,
                       paginationProps,
                       onOrderChange,
                       query
                     }) {
  return (
    <table>
      <HeadersDisciplines
        onChange={onOrderChange}
        value={query.order}
      />
      {disciplines.map(discipline => (
        <DisciplineItem
          discipline={discipline}
          key={discipline.id}
          navigateToDiscipline={navigateToDiscipline}
          checkedDisciplineIds={checkedDisciplineIds}
          discipline_ids={discipline_ids}
        />
      ))}
      <tr>
        <td colSpan="12">
          <TablePagination
            {...paginationProps}
          />
        </td>
      </tr>
    </table>
  );
}

DisciplineList.defaultProps = {};

DisciplineList.propTypes = {};

export default DisciplineList;



// WEBPACK FOOTER //
// ./src/components/Admin/Discipline/ListDisciplines/index.jsx